export default __webpack_public_path__ + "static/media/Railway Station - South.7b9f7671.jpg";